import React from "react";
import clsx from "clsx";

type RlNavigationItemProps = {
  children: React.ReactNode;
  className?: string;
  testId?: string;
  onClick?: (e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const RlNavigationItem = React.forwardRef<
  HTMLDivElement,
  RlNavigationItemProps
>(({ children, className, testId, onClick }, ref) => (
  <div
    ref={ref}
    className={clsx("main-nav__item", className)}
    data-testid={testId}
    onClick={e => {
      onClick?.(e);
    }}
  >
    {children}
  </div>
));

export default RlNavigationItem;
